/**
 * BUG-048 — jurisdiction / firm-style alternative section names
 * surfaced as a dropdown in the inline rename UI. Storing the
 * presets as a frontend-only constant per the cue (no backend
 * round-trip; presets evolve with drafter feedback faster than
 * the spec catalogue does).
 */
export interface SectionRenamePreset {
  label: string;
  /** Tag rendered next to the label so drafters know the
   * jurisdictional context — "EP default" / "US common" /
   * "Asian filings" / "alternative" / etc. */
  hint?: string;
}

export const SECTION_RENAME_PRESETS: Record<string, SectionRenamePreset[]> = {
  title: [
    { label: 'Title' },
    { label: 'Title of the invention', hint: 'EP/US verbose' },
  ],
  cross_reference: [
    { label: 'Cross-reference to related applications' },
    { label: 'Related applications', hint: 'US common' },
    { label: 'Priority claim', hint: 'alternative' },
  ],
  technical_field: [
    { label: 'Technical field' },
    { label: 'Field of the invention', hint: 'US common' },
    { label: 'Field', hint: 'short' },
  ],
  background_art: [
    { label: 'Background art', hint: 'EP default' },
    { label: 'Background of the invention', hint: 'US common' },
    { label: 'Prior art', hint: 'alternative' },
  ],
  summary: [
    { label: 'Summary of the invention' },
    { label: 'Brief summary', hint: 'US alternative' },
    { label: 'Technical problem and solution', hint: 'Asian filings' },
  ],
  brief_desc_drawings: [
    { label: 'Brief description of drawings' },
    { label: 'Brief description of the drawings', hint: 'EP/US' },
    { label: 'Description of figures', hint: 'alternative' },
  ],
  detailed_desc_drawings: [
    { label: 'Detailed description of drawings' },
    { label: 'Description of the drawings', hint: 'EP' },
  ],
  detailed_desc_embodiments: [
    { label: 'Detailed description of embodiments' },
    { label: 'Detailed description of the preferred embodiments' },
    { label: 'Detailed description of the invention', hint: 'US' },
  ],
  industrial_applicability: [
    { label: 'Industrial applicability', hint: 'EP/IN default' },
    { label: 'Utility', hint: 'alternative' },
  ],
  abstract: [
    { label: 'Abstract' },
    { label: 'Abstract of the disclosure', hint: 'US alternative' },
  ],
};

export function presetsForKind(kind: string): SectionRenamePreset[] {
  return SECTION_RENAME_PRESETS[kind] || [];
}
